export const SHOW_PARAMS = [ "spend", "revenue", "onwRevenue", "totalRevenue", "roi", "cutoff" ];
export const PAGE_LIMIT = 100;


// WEBPACK FOOTER //
// ./src/scenes/DynamicCutoff/config.js